import styled from 'styled-components';

import { SmallParagraph } from '../../../../../foundations/typefaces/SmallParagraph';
import { Color } from '../../types';

export const Wrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  width: '100%',
  gap: size.units(1),
  overflow: 'hidden',
}));

export const AdditionalInfoWrapper = styled.div(({ theme: { size } }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: size.units(1),
}));

export const BottomRightComponentWrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: size.units(1),
}));

export const TextWrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  overflow: 'hidden',
  justifyContent: 'center',

  [AdditionalInfoWrapper]: {
    marginTop: size.units(0.5),
  },

  [BottomRightComponentWrapper]: {
    marginLeft: 'auto',
  },
}));

export const StyledSmallParagraph = styled(SmallParagraph)<{ $color: Color }>(
  ({ theme: { color, transition }, $color }) => ({
    cursor: 'default',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color:
      $color === Color.TERTIARY
        ? color.content.tertiary.hover()
        : color.content.secondary.hover(),
    transition: transition.standard('color'),

    ':hover': {
      color:
        $color === Color.TERTIARY
          ? color.content.tertiary.hover()
          : color.content.secondary.hover(),
    },
  }),
);
